import { tv } from '@/ui/utils'

export const linkWebStyles = tv({
	base: 'text-ink select-text underline underline-offset-4 text-body1 font-bold',
})

export const linkNativeStyles = tv({
	base: 'text-ink text-body1 font-bold',
})
